import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Web16 = ({
  height = 16,
  width = 16,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.1875 14.5625H5.8125L6.25 11.9375H9.75L10.1875 14.5625Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 14.5625H11.5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.4375 9.60413H14.5625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8125 1.4375H3.1875C2.221 1.4375 1.4375 2.221 1.4375 3.1875V10.1875C1.4375 11.154 2.221 11.9375 3.1875 11.9375H12.8125C13.779 11.9375 14.5625 11.154 14.5625 10.1875V3.1875C14.5625 2.221 13.779 1.4375 12.8125 1.4375Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
